export default {"src":"/_next/static/media/github-bold.39738045.svg","height":20,"width":19,"blurWidth":0,"blurHeight":0};